export * from './info-box.component';
export * from './info-box.module';